/*
  Heldenpferde product custom blocks
  Extracted from product template custom_code blocks to avoid repeated inline <script> tags.
*/
(function () {
  function scrollToElement(element) {
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  window.scrollToFaq = function (event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    scrollToElement(document.querySelector('.product-faq-accordion'));
  };

  window.openFaqItem = function (event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    var targetElement = document.getElementById('faq-stallfreunde-deal');
    if (!targetElement) return;
    targetElement.open = true;
    window.setTimeout(function () {
      scrollToElement(targetElement);
    }, 100);
  };

  window.openPassformFaq = function (event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    var targetElement = document.getElementById('faq-passform-garantie');
    if (!targetElement) return;
    targetElement.open = true;
    window.setTimeout(function () {
      scrollToElement(targetElement);
    }, 100);
  };
})();
